<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form ref="form" :inline="true" label-width="100px" :model="searchData">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="id" label="介绍人编码">
                  <el-input class="jm-input-common3" clearable placeholder="多个用半角逗号分隔" v-model="searchData.id"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="id" label="介绍人姓名">
                  <el-input clearable v-model="searchData.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="咨询老师">
                  <el-select v-model="searchData.crm_sayer" clearable placeholder="请选择" filterable>
                    <el-option-group v-for="(group, k) in teachers" :key="k" :label="k">
                      <el-option
                        v-for="item in group"
                        :key="item.userid"
                        :label="item.truename"
                        :value="item.userid"
                      />
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建日期">
                  <el-date-picker
                    clearable
                    :editable="false"
                    v-model="searchData.creationDate"
                    type="daterange"
                    unlink-panels
                    placeholder="选择日期"
                    class="jm-input280"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="13">
                <el-form-item label="渠道">
                  <jm-channel v-model="channel" :is-all="true" clearable filterable />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="被介绍人签约日期" label-width="180">
                  <el-date-picker
                    clearable
                    :editable="false"
                    v-model="searchData.introducerSignDate"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    unlink-panels
                    placeholder="选择日期"
                    class="jm-input280"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="jm-tac jm-primary">
                <el-button type="primary" @click="doSearch">筛选</el-button>
                <el-button type="primary" @click="resetSearchForm">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
          <jm-table-list
            :refresh.sync="refresh"
            url="/index/student/introducerList"
            :search-data="searchData"
            row-key="id"
          >
            <el-table-column
              slot="firstColumn"
              type="expand">
              <template slot-scope="prop">
                <el-form
                  label-position="left"
                  class="behavior-expand">
                  <el-row
                    v-for="i in prop.row.users"
                    :key="i.id">
                    <el-col span="3">
                      <el-form-item label="客户编码">
                        <p>{{ i.id }}</p>
                      </el-form-item>
                    </el-col>
                    <el-col span="6">
                      <el-form-item label="姓名">
                        <p>{{ i.custom_name }} {{ i.custom_nickname_tell ? `/ ${i.custom_nickname_tell}` : '' }}</p>
                      </el-form-item>
                    </el-col>
                    <el-col span="3">
                      <el-form-item label="客户分级">
                        <p>{{ i.crm_level_lv }}</p>
                      </el-form-item>
                    </el-col>
                    <el-col span="6">
                      <el-form-item label="签约日期">
                        <p>{{ i.signing_date }}</p>
                      </el-form-item>
                    </el-col>
                    <el-col span="6">
                      <el-form-item label="创建日期">
                        <p>{{ i.create_time }}</p>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
              </template>
            </el-table-column>
            <el-table-column
              slot="gifts"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="gifts">
              <template slot-scope="scope">
                <p v-for="item in scope.row.gifts" :key="item.id">
                  <span :title="item.remark">【{{ item.gift_title }}】-{{ item.gift_time }}</span>
                  <el-button size="mini" type="error" @click="delGift(item.id)">删除</el-button>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              slot="user_count"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="user_count">
              <template slot-scope="scope">
                {{ scope.row.user_count[0] }} / {{ scope.row.user_count[1] }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              slot="lastColumn"
              label="操作"
              min-width="200"
              align="left">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="showGift(scope.row)">送礼</el-button>
              </template>
            </el-table-column>
          </jm-table-list>
          <el-dialog
            title="礼物信息"
            :visible.sync="dialogVisible"
            width="30%">
            <el-form>
              <el-form-item label="礼物类型">
                <el-select v-model="giftData.gift_title">
                  <el-option
                    v-for="item in giftDic"
                    :key="item"
                    :label="item"
                    :value="item"/>
                </el-select>
              </el-form-item>
              <el-form-item label="送礼时间">
                <el-date-picker
                  v-model="giftData.gift_time"
                  type="date"
                  unlink-panels
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  class="jm-input-common"/>
              </el-form-item>
              <el-form-item label="备注">
                <el-input clearable v-model="giftData.remark"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveGift()">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import studentMixin from './student';
import crumbs from '@/components/tool/crumbs';
import { jmChannel, jmDictSelect } from '@/components/tool';

export default {
  mixins: [studentMixin],
  components: {
    jmTableList,
    jmChannel,
    jmDictSelect,
    'jm-crumbs': crumbs,
  },
  data() {
    return {
      refresh: false,
      dialogVisible: false,
      channel: { },
      channel_id: '',
      searchData: { },
      giftData: {},
      giftDic: ['基础福利', '一级福利', '二级福利', '三级福利']
    };
  },
  computed: {
    teachers() {
      return this.ds.advisory_teacher;
    }
  },
  methods: {
    doSearch() {
      this.searchData.channel = this.channel;
      this.refresh = true;
    },
    resetSearchForm() {
      this.channel_id = '';
      this.channel = {};
      this.searchData = {
        showIgnore: false
      };
    },
    showGift(data) {
      this.dialogVisible = true;
      this.giftData = {};
      this.giftData.crm_id = data.id;
    },
    saveGift() {
      this.$http._post({
        url: '/index/student/saveGift',
        data: this.giftData
      }).then(() => {
        this.refresh = true;
        this.dialogVisible = false;
      });
    },
    delGift(id) {
      this.$confirm('此操作将永久删除该礼物日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/student/delGift',
          data: { id }
        }).then(() => {
          this.refresh = true;
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  },
  mounted() {
    this.getDatasource();
  }
};
</script>
